import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "details-content" }
const _hoisted_2 = { class: "transaction-header" }
const _hoisted_3 = { class: "header-info" }
const _hoisted_4 = { class: "info-row" }
const _hoisted_5 = { class: "info-value" }
const _hoisted_6 = { class: "info-row" }
const _hoisted_7 = { class: "info-label" }
const _hoisted_8 = { class: "info-value" }
const _hoisted_9 = { class: "info-row" }
const _hoisted_10 = { class: "info-value" }
const _hoisted_11 = { class: "info-row" }
const _hoisted_12 = { class: "info-label" }
const _hoisted_13 = { class: "info-value" }
const _hoisted_14 = { class: "info-row" }
const _hoisted_15 = { class: "view-header" }
const _hoisted_16 = {
  key: 0,
  class: "event-cancelled-badge"
}
const _hoisted_17 = { class: "wagers-card" }
const _hoisted_18 = { class: "table-container desktop-only" }
const _hoisted_19 = { class: "wagers-table" }
const _hoisted_20 = {
  key: 0,
  class: "results-numbers"
}
const _hoisted_21 = {
  key: 1,
  class: "no-results"
}
const _hoisted_22 = {
  key: 2,
  class: "no-results"
}
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "mobile-card mobile-only" }
const _hoisted_26 = { class: "card-row" }
const _hoisted_27 = { class: "card-value" }
const _hoisted_28 = { class: "card-row" }
const _hoisted_29 = { class: "card-value" }
const _hoisted_30 = {
  key: 0,
  class: "results-numbers"
}
const _hoisted_31 = {
  key: 1,
  class: "no-results"
}
const _hoisted_32 = {
  key: 2,
  class: "no-results"
}
const _hoisted_33 = { class: "card-row" }
const _hoisted_34 = { class: "card-value" }
const _hoisted_35 = { class: "card-row" }
const _hoisted_36 = { class: "card-value" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { class: "wagers-card" }
const _hoisted_40 = { class: "table-container desktop-only" }
const _hoisted_41 = { class: "wagers-table" }
const _hoisted_42 = { class: "market-name" }
const _hoisted_43 = { class: "market-text" }
const _hoisted_44 = { class: "selected-numbers" }
const _hoisted_45 = {
  key: 0,
  class: "cancelled-amount"
}
const _hoisted_46 = { key: 1 }
const _hoisted_47 = {
  key: 0,
  class: "cancelled-amount"
}
const _hoisted_48 = { key: 1 }
const _hoisted_49 = { class: "mobile-bets mobile-only" }
const _hoisted_50 = { class: "bet-card-header" }
const _hoisted_51 = { class: "bet-id" }
const _hoisted_52 = { class: "bet-card-body" }
const _hoisted_53 = { class: "bet-info-row" }
const _hoisted_54 = { class: "bet-value" }
const _hoisted_55 = { class: "market-name" }
const _hoisted_56 = { class: "market-text" }
const _hoisted_57 = {
  key: 0,
  class: "bet-info-row"
}
const _hoisted_58 = { class: "bet-value" }
const _hoisted_59 = { class: "selected-numbers" }
const _hoisted_60 = { class: "bet-info-row" }
const _hoisted_61 = { class: "bet-value" }
const _hoisted_62 = { class: "bet-info-row" }
const _hoisted_63 = { class: "bet-value" }
const _hoisted_64 = { class: "bet-info-row" }
const _hoisted_65 = { class: "bet-value" }
const _hoisted_66 = { class: "bet-info-row" }
const _hoisted_67 = { class: "bet-info-row" }
const _hoisted_68 = { class: "details-footer" }

import { computed } from "vue";

import type { TransactionDetail } from "@/stores/transactions";
import { formatCurrency } from "@/utils/currency";


const __default__ = {
  name: 'TransactionDetails',
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    transaction: {}
  },
  emits: ["rebet"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

// Check if transaction is settled based on bet statuses
const isTransactionSettled = computed(() => {
  for (const gameKey in props.transaction.games) {
    const games = props.transaction.games[gameKey];
    for (const game of games) {
      for (const bet of game.bets) {
        const betStatus = getBetStatus(bet, game);
        if (betStatus !== 'Settled') {
          return false;
        }
      }
    }
  }
  return true;
});

const getTransactionStatus = () => {
  for (const gameKey in props.transaction.games) {
    const games = props.transaction.games[gameKey];
    for (const game of games) {
      if (game.event_cancelled === 'yes') {
        return 'Cancelled';
      }
      for (const bet of game.bets) {
        const betStatus = getBetStatus(bet, game);
        if (betStatus === 'Cancelled') {
          return 'Cancelled';
        }
        if (betStatus !== 'Settled') {
          return 'Open';
        }
      }
    }
  }
  return 'Settled';
};

const hasLostSettledBets = () => {
  for (const gameKey in props.transaction.games) {
    const games = props.transaction.games[gameKey];
    for (const game of games) {
      for (const bet of game.bets) {
        if (getBetStatus(bet, game) === 'Settled' && Number(bet.winnings || 0) <= 0) {
          return true;
        }
      }
    }
  }
  return false;
};

const getTransactionStatusClass = () => {
  const status = getTransactionStatus();
  if (status === 'Settled' && hasLostSettledBets()) {
    return 'settled-zero';
  }
  return status.toLowerCase();
};

const handleRebet = () => {
  emit('rebet');
};


const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const seconds = date.getSeconds().toString().padStart(2, '0');
  
  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
};

const getBetStatus = (bet: any, game: any) => {
  // Check if the event is cancelled
  if (game.event_cancelled === "yes") {
    return "Cancelled";
  }
  // Check if the specific bet is cancelled
  if (bet.cancelled === true) {
    return "Cancelled";
  }
  // Return the original status if not cancelled
  return bet.status;
};

const getBetStatusClass = (bet: any, game: any) => {
  const status = getBetStatus(bet, game);
  if (status === 'Settled' && Number(bet.winnings || 0) <= 0) {
    return 'settled-zero';
  }
  return status.toLowerCase();
};

const getWinningNumbers = (game: any) => {
  if (game?.results && Array.isArray(game.results) && game.results.length > 0) {
    const flatResults = game.results.flat();
    return flatResults;
  }
  return [];
};

const isWinningBonusNumber = (index: number, game: any) => {
  if (game?.results && Array.isArray(game.results) && game.results.length > 1) {
    const mainNumbers = game.results[0] || [];
    return index >= mainNumbers.length;
  }
  
  return false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "info-label" }, "BETSLIP ID:", -1)),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.transaction.transaction.transaction_id), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('wagers.date')) + ":", 1),
          _createElementVNode("span", _hoisted_8, _toDisplayString(formatDate(_ctx.transaction.transaction.date)), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "info-label" }, "Reference:", -1)),
          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.transaction.transaction.reference), 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('wagers.description')) + ":", 1),
          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('wagers.wager')), 1)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "info-label" }, "Status:", -1)),
          _createElementVNode("span", {
            class: _normalizeClass(['info-value', 'status', getTransactionStatusClass()])
          }, _toDisplayString(getTransactionStatus()), 3)
        ])
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transaction.games, (games, gameKey) => {
      return (_openBlock(), _createElementBlock(_Fragment, null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(games, (game) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `${gameKey}-${game.draw_id}`,
            class: "game-section"
          }, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("h2", null, [
                _createTextVNode(_toDisplayString(game.name) + " - " + _toDisplayString(formatDate(game.draw_date)) + " ", 1),
                (game.event_cancelled === 'yes')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, "CANCELLED"))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("table", _hoisted_19, [
                  _cache[3] || (_cache[3] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "Draw ID"),
                      _createElementVNode("th", null, "Results"),
                      _createElementVNode("th", null, "Total Bet Amount"),
                      _createElementVNode("th", null, "Total Return")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", null, _toDisplayString(game.event_id || game.draw_id), 1),
                      _createElementVNode("td", null, [
                        (getWinningNumbers(game).length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getWinningNumbers(game), (number, index) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  key: index,
                                  class: _normalizeClass(['number-ball', { 'bonus': isWinningBonusNumber(index, game) }])
                                }, _toDisplayString(number), 3))
                              }), 128))
                            ]))
                          : (game.has_results && isTransactionSettled.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, " Pending Results "))
                            : (_openBlock(), _createElementBlock("div", _hoisted_22, " TBC "))
                      ]),
                      _createElementVNode("td", null, _toDisplayString(_unref(formatCurrency)(_ctx.transaction.transaction.total_cost, _ctx.transaction.transaction.currency_symbol)), 1),
                      _createElementVNode("td", null, [
                        (isTransactionSettled.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_unref(formatCurrency)(_ctx.transaction.transaction.total_winnings, _ctx.transaction.transaction.currency_symbol)), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_24, "TBC"))
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _cache[4] || (_cache[4] = _createElementVNode("span", { class: "card-label" }, "Draw ID:", -1)),
                  _createElementVNode("span", _hoisted_27, _toDisplayString(game.event_id || game.draw_id), 1)
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _cache[5] || (_cache[5] = _createElementVNode("span", { class: "card-label" }, "Results:", -1)),
                  _createElementVNode("div", _hoisted_29, [
                    (getWinningNumbers(game).length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getWinningNumbers(game), (number, index) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: index,
                              class: _normalizeClass(['number-ball', { 'bonus': isWinningBonusNumber(index, game) }])
                            }, _toDisplayString(number), 3))
                          }), 128))
                        ]))
                      : (game.has_results && isTransactionSettled.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, " Pending Results "))
                        : (_openBlock(), _createElementBlock("div", _hoisted_32, " TBC "))
                  ])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _cache[6] || (_cache[6] = _createElementVNode("span", { class: "card-label" }, "Total Bet Amount:", -1)),
                  _createElementVNode("span", _hoisted_34, _toDisplayString(_unref(formatCurrency)(_ctx.transaction.transaction.total_cost, _ctx.transaction.transaction.currency_symbol)), 1)
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _cache[7] || (_cache[7] = _createElementVNode("span", { class: "card-label" }, "Total Return:", -1)),
                  _createElementVNode("span", _hoisted_36, [
                    (isTransactionSettled.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(_unref(formatCurrency)(_ctx.transaction.transaction.total_winnings, _ctx.transaction.transaction.currency_symbol)), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_38, "TBC"))
                  ])
                ])
              ])
            ]),
            _cache[16] || (_cache[16] = _createElementVNode("div", { class: "view-header" }, [
              _createElementVNode("h2", null, " Your Bets ")
            ], -1)),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("table", _hoisted_41, [
                  _cache[8] || (_cache[8] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "Bet ID"),
                      _createElementVNode("th", null, "Your Bet"),
                      _createElementVNode("th", null, "Bet Type"),
                      _createElementVNode("th", null, "Odds"),
                      _createElementVNode("th", null, "Bet Amount"),
                      _createElementVNode("th", null, "Status"),
                      _createElementVNode("th", null, "Potential Returns"),
                      _createElementVNode("th", null, "Actual Returns")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(game.bets, (bet) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: bet.bet_id
                      }, [
                        _createElementVNode("td", null, _toDisplayString(bet.bet_id), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("span", _hoisted_42, _toDisplayString(bet.market_name) + ":", 1),
                          _createElementVNode("span", _hoisted_43, _toDisplayString(bet.market_text), 1),
                          _createElementVNode("div", _hoisted_44, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bet.bet_numbers, (numbers, index) => {
                              return (_openBlock(), _createElementBlock(_Fragment, null, [
                                (numbers.length > 0)
                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(numbers, (number) => {
                                      return (_openBlock(), _createElementBlock("span", {
                                        key: `${index}-${number}`,
                                        class: _normalizeClass(['number-ball', { 'bonus': index === 1 }])
                                      }, _toDisplayString(number), 3))
                                    }), 128))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 256))
                          ])
                        ]),
                        _createElementVNode("td", null, _toDisplayString(bet.betType), 1),
                        _createElementVNode("td", null, _toDisplayString(bet.odds), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.transaction.transaction.currency_symbol) + " " + _toDisplayString(bet.bet_cost), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("span", {
                            class: _normalizeClass(['status', getBetStatusClass(bet, game)])
                          }, _toDisplayString(getBetStatus(bet, game)), 3)
                        ]),
                        _createElementVNode("td", null, [
                          (getBetStatus(bet, game) === 'Cancelled')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString(_unref(formatCurrency)(0, _ctx.transaction.transaction.currency_symbol)), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(_unref(formatCurrency)(
                          bet.bet_cost * bet.odds,
                          _ctx.transaction.transaction.currency_symbol
                        )), 1))
                        ]),
                        _createElementVNode("td", null, [
                          (getBetStatus(bet, game) === 'Cancelled')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(_unref(formatCurrency)(0, _ctx.transaction.transaction.currency_symbol)), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString(bet.winnings
                          ? _unref(formatCurrency)(bet.winnings, _ctx.transaction.transaction.currency_symbol)
                          : _unref(formatCurrency)(0, _ctx.transaction.transaction.currency_symbol)), 1))
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_49, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(game.bets, (bet) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: bet.bet_id,
                    class: "bet-card"
                  }, [
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("span", _hoisted_51, "Bet ID: " + _toDisplayString(bet.bet_id), 1),
                      _createElementVNode("span", {
                        class: _normalizeClass(['status', getBetStatusClass(bet, game)])
                      }, _toDisplayString(getBetStatus(bet, game)), 3)
                    ]),
                    _createElementVNode("div", _hoisted_52, [
                      _createElementVNode("div", _hoisted_53, [
                        _cache[9] || (_cache[9] = _createElementVNode("span", { class: "bet-label" }, "Market:", -1)),
                        _createElementVNode("div", _hoisted_54, [
                          _createElementVNode("span", _hoisted_55, _toDisplayString(bet.market_name), 1),
                          _createElementVNode("span", _hoisted_56, _toDisplayString(bet.market_text), 1)
                        ])
                      ]),
                      (bet.bet_numbers && (bet.bet_numbers[0]?.length > 0 || bet.bet_numbers[1]?.length > 0))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                            _cache[10] || (_cache[10] = _createElementVNode("span", { class: "bet-label" }, "Numbers:", -1)),
                            _createElementVNode("div", _hoisted_58, [
                              _createElementVNode("div", _hoisted_59, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bet.bet_numbers, (numbers, index) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                                    (numbers.length > 0)
                                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(numbers, (number) => {
                                          return (_openBlock(), _createElementBlock("span", {
                                            key: `${index}-${number}`,
                                            class: _normalizeClass(['number-ball', { 'bonus': index === 1 }])
                                          }, _toDisplayString(number), 3))
                                        }), 128))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                }), 256))
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_60, [
                        _cache[11] || (_cache[11] = _createElementVNode("span", { class: "bet-label" }, "Bet Type:", -1)),
                        _createElementVNode("span", _hoisted_61, _toDisplayString(bet.betType), 1)
                      ]),
                      _createElementVNode("div", _hoisted_62, [
                        _cache[12] || (_cache[12] = _createElementVNode("span", { class: "bet-label" }, "Odds:", -1)),
                        _createElementVNode("span", _hoisted_63, _toDisplayString(bet.odds), 1)
                      ]),
                      _createElementVNode("div", _hoisted_64, [
                        _cache[13] || (_cache[13] = _createElementVNode("span", { class: "bet-label" }, "Bet Amount:", -1)),
                        _createElementVNode("span", _hoisted_65, _toDisplayString(_unref(formatCurrency)(bet.bet_cost, _ctx.transaction.transaction.currency_symbol)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_66, [
                        _cache[14] || (_cache[14] = _createElementVNode("span", { class: "bet-label" }, "Potential Returns:", -1)),
                        _createElementVNode("span", {
                          class: _normalizeClass(['bet-value', { 'cancelled-amount': getBetStatus(bet, game) === 'Cancelled' }])
                        }, _toDisplayString(getBetStatus(bet, game) === 'Cancelled'
                        ? _unref(formatCurrency)(0, _ctx.transaction.transaction.currency_symbol)
                        : _unref(formatCurrency)(
                            bet.bet_cost * bet.odds,
                            _ctx.transaction.transaction.currency_symbol
                          )), 3)
                      ]),
                      _createElementVNode("div", _hoisted_67, [
                        _cache[15] || (_cache[15] = _createElementVNode("span", { class: "bet-label" }, "Actual Returns:", -1)),
                        _createElementVNode("span", {
                          class: _normalizeClass(['bet-value', { 'cancelled-amount': getBetStatus(bet, game) === 'Cancelled' }])
                        }, _toDisplayString(getBetStatus(bet, game) === 'Cancelled'
                        ? _unref(formatCurrency)(0, _ctx.transaction.transaction.currency_symbol)
                        : bet.winnings
                          ? _unref(formatCurrency)(bet.winnings, _ctx.transaction.transaction.currency_symbol)
                          : _unref(formatCurrency)(0, _ctx.transaction.transaction.currency_symbol)), 3)
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]))
        }), 128))
      ], 64))
    }), 256)),
    _createElementVNode("div", _hoisted_68, [
      _createElementVNode("button", {
        type: "button",
        class: "rebet-button",
        onClick: handleRebet
      }, _toDisplayString(_ctx.$t('wagers.rebet')), 1)
    ])
  ]))
}
}

})